import { Button } from '@postidigital/posti-components'
import { observer } from 'mobx-react-lite'
import React, { FC, useCallback } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { AppModal, ContentSection } from '../../components'
import { ResponsiveBody } from '../../components/typography/ResponsiveBody'
import { ICountdownResponse } from '../../hooks/useCountdown'

const AccountRecoveryLogoutModal: FC<{
  countDownData: ICountdownResponse['data']
  reset: ICountdownResponse['reset']
  logout: () => void
}> = ({ countDownData: { minutes, seconds }, reset, logout }) => {
  const { t } = useTranslation()

  const getTimeLabel = useCallback(
    (time: number, format: 'm' | 's') => {
      if (time === 1) {
        if (format === 'm') {
          return t(`accountRecovery.time.minute`)
        }

        return t(`accountRecovery.time.second`)
      }

      if (format === 'm') {
        return t(`accountRecovery.time.minutes`)
      }

      return t(`accountRecovery.time.seconds`)
    },
    [t]
  )

  const timeString = `${minutes > 0 ? `${minutes} ${getTimeLabel(minutes, 'm')}` : ''}${
    seconds > 0 ? ` ${seconds} ${getTimeLabel(seconds, 's')}` : ''
  }`

  if (minutes > 2) {
    return null
  }

  return (
    <AppModal
      id="account_recovery_logout_modal"
      isOpen
      title={t('accountRecovery.reset.sessionModal.title')}
      showCloseButton={false}
      onClose={reset}
      contentPadding="0 2rem"
      controls={
        <>
          <Button id="account_recovery_exit" contentMode="secondary" onClick={logout} size="sm">
            {t('accountRecovery.reset.sessionModal.exit')}
          </Button>
          <Button id="account_recovery_continue" type="button" contentMode="primary" onClick={reset} size="sm">
            {t('accountRecovery.reset.sessionModal.continue')}
          </Button>
        </>
      }
    >
      <ContentSection>
        <ResponsiveBody style={{ whiteSpace: 'pre-line' }}>
          <Trans
            i18nKey="accountRecovery.reset.sessionModal.content"
            values={{ time: timeString }}
            components={[<b key="bold" />, <br key="line-break" />]}
          />
        </ResponsiveBody>
      </ContentSection>
    </AppModal>
  )
}

export default observer(AccountRecoveryLogoutModal)
